export enum PriceMovementStatus {
  NO_CHANGE,
  INCREASED,
  DECREASED,
}
